import TituloPrincipalH1 from '@/components/elements/TituloPrincipalH1';
import { useTranslation } from 'next-i18next';
import React, { } from 'react';
import Exporter from './Exporter';

function ImportarExportar() {
    const { t } = useTranslation();

    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <TituloPrincipalH1 texto={t("menu:secciones.importar_exportar.titulo")} />
            <Exporter />
        </section>
    );
}

export default ImportarExportar;